import { Toaster } from '@procureai/uix';
import { Suspense } from 'react';

import { RouteTracker } from '../RouteTracker/RouteTracker';
import { AppProviders } from '~/components/AppProviders/AppProviders';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { HtmlPageTitle } from '~/components/HtmlPageTitle/HtmlPageTitle';
import { Routes } from '~/routes/Routes';

import { Root } from './App.styled';

export const App = () => {
  return (
    <Suspense fallback={<CircularProgressCentered />}>
      <AppProviders>
        <HtmlPageTitle />
        <Root>
          <RouteTracker />
          <Routes />
          <Toaster />
        </Root>
      </AppProviders>
    </Suspense>
  );
};
